module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.clickaway),
      expression: "clickaway"
    }],
    staticClass: "school-year pos-relative",
    class: {
      'white-theme': _vm.whiteTheme
    }
  }, [(_vm.schoolYears.length > 1) ? _c('div', {
    staticClass: "school-year__active pointer",
    class: {
      'isActive': _vm.showDropdown
    },
    on: {
      "click": function($event) {
        _vm.showDropdown = !_vm.showDropdown
      }
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.activeSchoolYear.name))]), _vm._v(" "), _c('span', {
    staticClass: "icon-arrow-down4"
  })]) : _c('div', {
    staticClass: "school-year__active"
  }, [_c('p', [_vm._v(_vm._s(_vm.activeSchoolYear.name))])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "dropdown"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showDropdown),
      expression: "showDropdown"
    }],
    staticClass: "school-year__active__dropdown"
  }, [_c('ul', _vm._l((_vm.schoolYears), function(year) {
    return _c('li', {
      on: {
        "click": function($event) {
          return _vm.setActiveSchoolYear(year.id)
        }
      }
    }, [_vm._v(_vm._s(year.name))])
  }), 0)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e014dd16!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/School/ChangeSchoolYear.vue
// module id = 1832
// module chunks = 1